var lists_default = {
  "fontElementMap": "Dubms",
  "orderedlist": "TGx5o",
  "bulletedlist": "_0vzFh",
  "listItem": "QtYXk"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
